import ImageWithFallback from "components/ImageWithFallback"
import Isotope from "isotope-layout"
import CategoryCard from "plugin/CategoryShortcuts/CategoryCard"

import IsotopeCards from "plugin/CategoryShortcuts/IsotopeCards"
import MasonryCard from "plugin/CategoryShortcuts/MasonryCard"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Card, Container } from "semantic-ui-react"
import cmsStore from "stores/cmsStore"
import "style/CategoryCard.scss"

window[ "Isotope" ] = Isotope

export default class CategoryShortcuts extends Component {

  render() {
    const { category, itemsPerRow } = this.props
    const hasData = category && category.children.length > 0
    const title = this.props.title
    const useTitlebar = title && hasData
    const { masonryCategories } = cmsStore.config.plugin
    const isRoot = !category || category.map_id === undefined
    const computedItemsPerRow = (typeof window !== "undefined" && window.innerWidth < 768)
      ? 1
      : (itemsPerRow ? itemsPerRow : 3)
    console.log("CategoryShortcuts render", { category, itemsPerRow, computedItemsPerRow, hasData, masonryCategories, isRoot })
    return (
      <div className="MasonryContainer">
      {hasData && this.props.children}
      {hasData && <div className="">
        {useTitlebar && <h2 className="mt2 ttu">{title}</h2>}
        <Card.Group itemsPerRow={computedItemsPerRow} doubling>
          {category.children.map(subcat => {
          return <CategoryCard
            fallback={"//placehold.it/420x240/929673/&text=X"}
            hasParents={category.map_id} parents={[category.map_id]} key={subcat.map_id}
            category={subcat} itemsPerRow={computedItemsPerRow} />
          })}
        </Card.Group>
      </div>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/theme/lucht-test/plugin/CategoryShortcuts/CategoryShortcuts.js